import script from "./SponsorDonations.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorDonations.vue?vue&type=script&setup=true&lang=js"

import "./SponsorDonations.vue?vue&type=style&index=0&id=1b6eba68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6eba68"]])

export default __exports__